import { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface PortalContextProps {
  viewMenu: boolean;
  setViewMenu: (value: boolean) => void;
  isMovil: boolean;
  setIsMovil: (value: boolean) => void;
}

const PortalContext = createContext<PortalContextProps | undefined>(undefined);

const MOBILE_BREAKPOINT = 768;

const computeIsMobile = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
};

export const PortalProvider = ({ children }: { children: ReactNode }) => {
  const [viewMenu, setViewMenu] = useState(true);
  const [isMovil, setIsMovil] = useState(computeIsMobile);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

    const listener = () => setIsMovil(media.matches);

    media.addEventListener("change", listener);
    window.visualViewport?.addEventListener("resize", listener);

    return () => {
      media.removeEventListener("change", listener);
      window.visualViewport?.removeEventListener("resize", listener);
    };
  }, []);

  return (
    <PortalContext.Provider value={{ viewMenu, setViewMenu, isMovil, setIsMovil }}>
      {children}
    </PortalContext.Provider>
  );
};

export const usePortal = (): PortalContextProps => {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error("usePortal debe usarse dentro de PortalProvider");
  }
  return context;
};
